<template lang="pug">
div
  v-card(flat)
    v-card-title Restroom Facilities
    keep-alive
      validation-observer(
        ref="o10",
        v-slot="{ invalid }",
        :persist="true",
        vid="o10"
      )
        v-container 
          v-row
            v-col(:lg="12", :md="12", :sm="12", :cols="12")
              p.pb-0.body-1 Are there restroom facilities at the site?
              v-radio-group(
                v-model="SEA_Restrooms",
                row,
                dense,
                :disabled="disabled"
              )
                v-radio(
                  v-for="option in yesNoString",
                  :key="option",
                  :label="option",
                  :value="option"
                )
          v-row(v-if="SEA_Restrooms === 'Yes'")
            v-col(:lg="12", :md="12", :sm="12", :cols="12")
              p.pb-0.body-1 Number of toilet fixtures inside
          v-row(v-if="SEA_Restrooms === 'Yes'")
            v-col(:lg="3", :md="3", :sm="12", :cols="12")
              p.pb-0.body-1 Male toilets
            v-col(:lg="9", :md="9", :sm="12", :cols="12")
              v-text-field.pb-3.pl-3(
                outlined,
                hide-details,
                dense,
                v-model="SEA_RestroomInsideMale",
                :disabled="disabled"
              )
          v-row(v-if="SEA_Restrooms === 'Yes'")
            v-col(:lg="3", :md="3", :sm="12", :cols="12")
              p.pb-0.body-1 Female toilets
            v-col(:lg="9", :md="9", :sm="12", :cols="12")
              v-text-field.pb-3.pl-3(
                outlined,
                hide-details,
                dense,
                v-model="SEA_RestroomInsideFemale",
                :disabled="disabled"
              )
          v-row(v-if="SEA_Restrooms === 'Yes'")
            v-col(:lg="3", :md="3", :sm="12", :cols="12")
              p.pb-0.body-1 Handicap toilets
            v-col(:lg="9", :md="9", :sm="12", :cols="12")
              v-text-field.pb-3.pl-3(
                outlined,
                hide-details,
                dense,
                v-model="SEA_RestroomInsideHandicap",
                :disabled="disabled"
              )
          v-row
            v-col(:lg="12", :md="12", :sm="12", :cols="12")
              p.pb-0.body-1 Number of portable toilets outside
          v-row
            v-col(:lg="3", :md="3", :sm="12", :cols="12")
              p.pb-0.body-1 Male portable toilets
            v-col(:lg="9", :md="9", :sm="12", :cols="12")
              v-text-field.pb-3.pl-3(
                outlined,
                hide-details,
                dense,
                v-model="SEA_RestroomOutsideMale",
                :disabled="disabled"
              )
          v-row
            v-col(:lg="3", :md="3", :sm="12", :cols="12")
              p.pb-0.body-1 Female portable toilets
            v-col(:lg="9", :md="9", :sm="12", :cols="12")
              v-text-field.pb-3.pl-3(
                outlined,
                hide-details,
                dense,
                v-model="SEA_RestroomOutsideFemale",
                :disabled="disabled"
              )
          v-row
            v-col(:lg="3", :md="3", :sm="12", :cols="12")
              p.pb-0.body-1 Handicap portable toilets
            v-col(:lg="9", :md="9", :sm="12", :cols="12")
              v-text-field.pb-3.pl-3(
                outlined,
                hide-details,
                dense,
                v-model="SEA_RestroomOutsideHandicap",
                :disabled="disabled"
              )
          v-row
            v-col(:lg="12", :md="12", :sm="12", :cols="12")
              p.pb-0.body-1 Are there hand‐washing facilities convenient to toilets?
              v-radio-group(
                v-model="SEA_RestroomHandWashing",
                row,
                dense,
                :disabled="disabled"
              )
                v-radio(
                  v-for="option in yesNoString",
                  :key="option",
                  :label="option",
                  :value="option"
                )
          v-row
            v-col(:lg="12", :md="12", :sm="12", :cols="12")
              p.pb-0.body-1 If you are contracting for restroom facilities, what is the name of the company you are contracting?
              v-text-field.pb-3.pl-3(
                outlined,
                hide-details,
                dense,
                v-model="SEA_RestroomContracting",
                :disabled="disabled"
              )
</template>


<script>
import { mapState } from "vuex";
import { mapFields } from "vuex-map-fields";
import store from "../store";

export default {
  components: {
    //
  },
  store,
  computed: {
    ...mapState({
      data: (state) => state.data,
      yesNoString: (state) => state.yesNoString,
    }),
    ...mapFields([
      "data.SEA_Restrooms",
      "data.SEA_RestroomInsideMale",
      "data.SEA_RestroomInsideFemale",
      "data.SEA_RestroomInsideHandicap",
      "data.SEA_RestroomOutsideMale",
      "data.SEA_RestroomOutsideFemale",
      "data.SEA_RestroomOutsideHandicap",
      "data.SEA_RestroomHandWashing",
      "data.SEA_RestroomContracting",
      "data.disabled",
    ]),
  },
  data: () => ({
    //
  }),
  methods: {
    //
  },
};
</script>